export const ORDER_TABS = {
  JOBS: 'jobs',
  DETAIL: 'detail',
  DISCOUNTS: 'discounts',
  PROFITABILITY: 'profitability',
  ALL_ITEMS: 'allItems',
  DOCUMENTS: 'documents',
  PARTS_MOVEMENTS: 'partsMovements',
  COMMENTS_NOTES: 'commentsNotes',
  ACTIVITY_LOG: 'activityLog',
  CHECKOUT: 'checkout',
  CHECKLISTS: 'checklists',
};
